import { usePathname, useSearchParams } from 'next/navigation';
import { isConcertsPage } from './util';

export function useIsConcerts() {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  return isConcertsPage(pathname, searchParams?.get('parentId'));
}
